module.exports = __webpack_public_path__ + "img/download.319870d9.png";